import request from './request'
// 首页-banner
export function banner(callback) {
    request.get('banner/index').then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//服务列表
export function server(callback) {
    request.get('server/index').then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//公司简介
export function company_profile(callback) {
    request.get('company_profile/index').then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//首页-最新新闻
export function news_news(callback) {
    request.get('news/news').then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//首页-热门新闻
export function news_top(callback) {
    request.get('news/top').then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//荣誉资质
export function honor_customer(callback) {
    request.get('honor_customer/index', { page: 1, per_page: 999 }).then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//首页-最新新闻
export function nav(callback) {
    request.get('nav/index').then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//企业文化
export function company_culture(callback) {
    request.get('company_culture/index').then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//社会责任
export function our_mission(callback) {
    request.get('our_mission/index').then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//社会责任
export function branded_advantages(callback) {
    request.get('branded_advantages/index').then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//社会责任
export function development_path(callback) {
    request.get('development_path/index').then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//荣誉资质
export function honor(callback) {
    request.get('honor/index', { page: 1, per_page: 999 }).then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//案例分类
export function case_cate(callback) {
    request.get('case_cate/index').then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//案例列表
export function cases({ cate_id, page }, callback) {
    request.post('cases/index', { cate_id, page }).then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//新闻列表
export function news(page, callback) {
    request.get('news/index', { page, per_page: 9 }).then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//联系我们
export function config(callback) {
    request.get('config/index').then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//服务详情
export function server_details(id, callback) {
    request.get('server/details', id).then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//服务详情
export function news_details(id, callback) {
    request.get('news/details', id).then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}
//案例详情
export function cases_details(id, callback) {
    request.get('cases/details', id).then(r => {
        callback && typeof callback === 'function' && callback(r)
    })
}

